export function sendUserDataInCrisp(user) {
  if (!user || !user?.name) return () => {};
  /** eslint-disable-next-line */
  if (typeof window.$crisp !== 'undefined') {
    window.$crisp.push(['set', 'user:nickname', [user.name]]);
    window.$crisp.push(['set', 'user:email', [user.email]]);
  }
}
